// Shared constants + tiny helpers for the weekly AI planner surfaces.

export const PLANNER_GOALS = [
  { id: "balanced", label: "BALANCED", blurb: "All macro groups, veg every day, rotating proteins." },
  { id: "satiating", label: "SATIATING", blurb: "Maximum fullness per calorie — protein + fiber volume." },
  { id: "high_protein", label: "HIGH-PROTEIN", blurb: "35g+ per main meal. A bulk week." },
  { id: "low_calorie", label: "LOW-CALORIE", blurb: "Lighter plates that protect protein. A cut week." },
];

export const PLANNER_BUDGETS = [
  { id: "frugal", label: "FRUGAL", blurb: "Staples, stretched proteins." },
  { id: "normal", label: "NORMAL", blurb: "Everyday supermarket." },
  { id: "upscale", label: "UPSCALE", blurb: "A treat week. Premium plates." },
];

// Book-share dial. `book` is the fraction of filled slots pulled from
// the user's recipe book (the rest are new concepts).
export const PLANNER_SOURCES = [
  { id: "book", label: "MY RECIPES", book: 1, blurb: "The whole week from your book — forgotten favorites first." },
  { id: "mixed", label: "MIX", book: 0.6, blurb: "Mostly your book, a few experimental nights." },
  { id: "new", label: "ALL NEW", book: 0, blurb: "An experimental week of brand-new dishes." },
];

export const PLANNER_NEW_MODES = [
  { id: "classics", label: "CLASSICS", blurb: "Beloved, recognizable dishes." },
  { id: "chefs_choice", label: "CHEF'S CHOICE", blurb: "Full creative freedom." },
  { id: "pantry", label: "PANTRY-FIRST", blurb: "Built strictly from what's in stock." },
];

export const MEAL_SLOTS = ["breakfast", "lunch", "dinner"];
export const SLOT_LABELS = { breakfast: "BREAKFAST", lunch: "LUNCH", dinner: "DINNER" };

export const COST_TIER_LABELS = { 1: "$", 2: "$$", 3: "$$$" };

export const DAY_SHORT = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];

// Day label for a plan-relative day index against a week_start date
// string ("2026-07-13"). Uses the actual weekday so Sunday-start weeks
// (US) label correctly.
export function dayLabelFor(weekStartISO, day) {
  const [y, m, d] = String(weekStartISO || "").split("-").map(Number);
  if (!y) return DAY_SHORT[day % 7] || `DAY ${day}`;
  const date = new Date(y, (m || 1) - 1, (d || 1) + Number(day || 0));
  return date.toLocaleDateString([], { weekday: "short" }).toUpperCase();
}

export function dayDateFor(weekStartISO, day) {
  const [y, m, d] = String(weekStartISO || "").split("-").map(Number);
  if (!y) return "";
  const date = new Date(y, (m || 1) - 1, (d || 1) + Number(day || 0));
  return date.toLocaleDateString([], { month: "short", day: "numeric" });
}

// Local-date ISO ("2026-07-13") — never toISOString (UTC shifts the
// date across midnight for western timezones).
export function toLocalISODate(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

// The 21 default slot requests — everything enabled.
export function defaultSlots() {
  const out = [];
  for (let day = 0; day < 7; day++) {
    for (const slot of MEAL_SLOTS) out.push({ day, slot, enabled: true });
  }
  return out;
}

export const slotKey = (s) => `${s.day}:${s.slot}`;
